{
  "dropLabel": "Jump to specific question",
  "nextLabel": "<b>Answer health questions</b>",
  "questions": {
    "allergies": {
      "detailsPlaceholder": "e.g. Penicillin – rash and swelling; Latex – mild irritation",
      "label": "Do you have any allergies?",
      "nextLabel": "$t(common:next): <b>Weight and height</b>",
      "title": "<h3>Allergies</h3>"
    },
    "arrhythmias": {
      "detailsPlaceholder": "e.g. Irregular heartbeat, on beta blockers",
      "label": "Do you have irregular heartbeat, palpitations, or a heart murmur?",
      "nextLabel": "$t(common:next): <b>Pacemaker</b>",
      "title": "<h3>Arrhythmias (irregular heart rate)</h3>"
    },
    "asthmaLungConditions": {
      "detailsPlaceholder": "e.g. Mild asthma – use inhaler occasionally",
      "label": "Do you have asthma, COPD or any other lung condition?",
      "nextLabel": "$t(common:next): <b>Digestive conditions</b>",
      "title": "<h3>Asthma or lung conditions</h3>"
    },
    "bloodProblems": {
      "detailsPlaceholder": "e.g. Easy bruising – diagnosed with Von Willebrand disease",
      "label": "Do you have any bleeding or clotting disorders, or bruise easily?",
      "nextLabel": "$t(common:next): <b>Organ transplant</b>",
      "title": "<h3>Blood disorders or bleeding problems</h3>"
    },
    "bloodThinningMedication": {
      "detailsPlaceholder": "e.g. Apixaban, Warfarin, Rivaroxaban, Dabigatran, Ticagrelor, Clopidogrel",
      "label": "Are you currently taking any blood thinning medication other than aspirin?",
      "nextLabel": "$t(common:next): <b>Heart conditions</b>",
      "title": "<h3>Blood thinning medication</h3>"
    },
    "cancerTreatment": {
      "detailsPlaceholder": "e.g. Chemotherapy for breast cancer – ongoing",
      "label": "Are you currently receiving chemotherapy, radiotherapy or any other treatment for cancer?",
      "nextLabel": "$t(common:next): <b>Infectious diseases</b>",
      "title": "<h3>Cancer treatment</h3>"
    },
    "diabetes": {
      "detailsLabel": "How is your diabetes managed?",
      "diet-controlled": "Diet-controlled",
      "insulin": "Insulin",
      "label": "Do you have diabetes?",
      "nextLabel": "$t(common:next): <b>High blood pressure</b>",
      "no": "No",
      "tablets": "Tablets (e.g. Metformin)",
      "title": "<h3>Diabetes</h3>",
      "type-1": "Type 1 - on insulin",
      "type-2": "Type 2",
      "yes-type-1": "Yes - Type 1 on insulin",
      "yes-type-2": "Yes - Type 2"
    },
    "digestiveConditions": {
      "detailsPlaceholder": "e.g. Reflux managed with omeprazole",
      "label": "Do you have GORD (reflux), IBS, or IBD?",
      "nextLabel": "$t(common:next): <b>Blood or bleeding problems</b>",
      "title": "<h3>Digestive conditions</h3>"
    },
    "epilepsy": {
      "detailsPlaceholder": "e.g. Last seizure in 2020 – currently stable",
      "label": "Do you have epilepsy or a history of seizures?",
      "nextLabel": "$t(common:next): <b>Neurological conditions</b>",
      "title": "<h3>Epilepsy</h3>"
    },
    "glp1Medications": {
      "detailsPlaceholder": "e.g. Wegovy, Ozempic, Trulicity, Saxenda, Victoza, Mournjaro",
      "detailsLabel": "Which one?",
      "label": "Are you currently taking any GLP-1 medications (often used for diabetes or weight management)?",
      "nextLabel": "$t(common:next): <b>Other medications</b>",
      "title": "<h3>GLP-1 medications</h3>"
    },
    "heartConditions": {
      "detailsPlaceholder": "e.g. Heart attack in 2020 – stent inserted",
      "label": "Have you ever had a heart condition (e.g. heart attack, angina)?",
      "nextLabel": "$t(common:next): <b>Stroke or mini-stroke (TIA)</b>",
      "title": "<h3>Heart conditions</h3>"
    },
    "highBloodPressure": {
      "detailsPlaceholder": "e.g. Diagnosed in 2018 – managed with medication",
      "label": "Do you have high blood pressure?",
      "nextLabel": "$t(common:next): <b>Irregular heart rate</b>",
      "title": "<h3>High blood pressure</h3>"
    },
    "infectiousDiseases": {
      "detailsPlaceholder": "e.g. MRSA",
      "label": "Have you ever tested positive for MRSA, ESBL, VRE or CPE?",
      "nextLabel": "$t(common:next): <b>Pregnancy</b>",
      "title": "<h3>Multi-resistant organisms</h3>"
    },
    "metalImplants": {
      "detailsPlaceholder": "e.g. Right hip replacement, dental implants, or metal rod in leg",
      "label": "Do you have any metal implants or metalware on your body? (e.g. pins, plates, screws, joint replacements)",
      "nextLabel": "$t(common:next): <b>Diabetes</b>",
      "title": "<h3>Implants or metal</h3>"
    },
    "obstructiveSleepApnoea": {
      "detailsPlaceholder": "e.g. Diagnosed in 2022 – use CPAP machine every night",
      "label": "Do you have obstructive sleep apnoea or use a CPAP machine at night when sleeping?",
      "nextLabel": "$t(common:next): <b>Asthma or lung conditions</b>",
      "title": "<h3>Obstructive sleep apnoea</h3>"
    },
    "organTransplant": {
      "detailsPlaceholder": "e.g. Kidney transplant in 2018 – taking tacrolimus and prednisone",
      "label": "Have you had an organ transplant and are you taking immunosuppressive medication?",
      "nextLabel": "$t(common:next): <b>Cancer treatment</b>",
      "title": "<h3>Organ transplant</h3>"
    },
    "otherHealthConditions": {
      "detailsPlaceholder": "e.g. Coeliac disease, recent surgery, chronic pain",
      "label": "Do you have any other medical conditions or concerns we should know about?",
      "nextLabel": "$t(common:next): <b>GLP-1 Medications</b>",
      "title": "<h3>Other health conditions</h3>"
    },
    "pacemaker": {
      "defibrillator": "Defibrillator",
      "detailsLabel": "What type is it?",
      "label": "Do you have a pacemaker or other implanted cardiac device?",
      "nextLabel": "$t(common:next): <b>Blood thinning medications</b>",
      "not-sure": "I’m not sure",
      "pacing": "Pacing",
      "title": "<h3>Pacemaker or implanted cardiac device</h3>"
    },
    "pregnancy": {
      "detailsLabel": "How many weeks?",
      "detailsPlaceholder": "Enter number of weeks",
      "label": "Are you currently - or possibly - pregnant?",
      "nextLabel": "$t(common:next): <b>Other conditions</b>",
      "title": "<h3>Pregnancy</h3>"
    },
    "stroke": {
      "detailsPlaceholder": "e.g. Stroke in 2021 – mild weakness on left side",
      "label": "Have you had a stroke or mini-stroke?",
      "nextLabel": "$t(common:next): <b>Epilepsy</b>",
      "title": "<h3>Stroke or mini-stroke (TIA)</h3>"
    },
    "weightHeight": {
      "cm": "cm",
      "height": "Height",
      "kg": "kg",
      "nextLabel": "$t(common:next): <b>Implants or metal</b>",
      "title": "<h3>Weight and height</h3><p>Please enter your</p>",
      "weight": "Weight"
    }
  },
  "text": "<p>We’re nearly done.</p><p>We just need to ask a few questions about your health, medications, and preferences.</p><p>It’s important we understand anything that could affect your care.</p><p>If we need to clarify anything, one of our team will be in touch before your procedure.</p><p>This last part of the process usually takes less than <strong>10 minutes</strong>.</p>",
  "title": "Health and preference questions"
}
